import parseSurveyListConfig from '../parseSurveyListConfig'
import SurveyCollection from '../SurveyCollection'
import surveyListRaw from './surveyList.yml?raw'

export { surveyListRaw }

const surveyListParsingResult = parseSurveyListConfig(surveyListRaw)

if (!surveyListParsingResult.isValid) {
  throw new Error('Invalid survey list')
}

export default new SurveyCollection(surveyListParsingResult.data.surveys)
